export default __webpack_public_path__ + "static/media/external-link-grey.2a1ab827.svg";